import { defineStyleConfig } from '@chakra-ui/react'

export default defineStyleConfig({
  baseStyle: {
    fontWeight: 'normal',
    borderRadius: 'sm',
  },
  defaultProps: {
    size: 'sm',
  },
})
